
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {readForm} from '@/store/main/getters';
import DefaultHelp from '@/components/tooltips/DefaultHelp.vue';
import {
  EnumLogicalOperator,
  EnumQueryBuilderType,
  EnumQueryOperators,
  EnumReturnMode,
  IQueryBuilder,
} from '@/interfaces/query-builder';
import {commitSetQueryBuilder} from '@/store/main/mutations';
import {rules} from '@/utils';

@Component({
  components: {DefaultHelp},
})
export default class QueryBuilder extends Vue {
  @Prop(Number) public formId;
  @Prop() public queryBuilderUpdated;
  private rules: any = rules;
  private selectedField: any = null;
  private search: any = null;
  private enumOp: any = EnumQueryOperators;
  private queryBuilder: any = {} as IQueryBuilder;

  @Watch('$route')
  public watchRoute() {
    this.loadMountedSettings();
  }

  @Watch('queryBuilder')
  public watchQueryBuilder(val) {
    commitSetQueryBuilder(this.$store, val);
  }

  public async mounted() {
    this.loadMountedSettings();
  }

  private get isDisabled() {
    if (this.queryBuilder?.children) {
      return !this.queryBuilder?.children[0]?.query.operand;
    }
    return false;
  }

  public loadMountedSettings() {
    this.queryBuilder = {
      return_mode: EnumReturnMode.RM_ANY,
      type: EnumQueryBuilderType.SEARCH_ENGINE,
      children: [
        {
          logical_operator: null,
          query: {
            query_value: null,
            operator: this.enumOp.OP_EQUAL,
            operand: null,
          },
        },
      ],
    } as IQueryBuilder;

    if (this.queryBuilderUpdated) {
      this.queryBuilder = {...this.queryBuilderUpdated};
    }

  }

  /* tslint:disable */
  private get operators() {
    return [
      {name: 'Igual', value: EnumQueryOperators.OP_EQUAL},
      {name: 'Diferente de', value: EnumQueryOperators.OP_NOT_EQUAL},
      {name: 'Contém', value: EnumQueryOperators.OP_CONTAINS},
      {name: 'Não Contém', value: EnumQueryOperators.OP_NOT_CONTAINS},
      // {name: 'Está Entre', value: 'in_'},
      // {name: 'Não Está Entre', value: 'not_in_'},
    ];
  }

  private get operatorsNumerics() {
    return [
      {name: 'Igual', value: EnumQueryOperators.OP_EQUAL},
      {name: 'Diferente de', value: EnumQueryOperators.OP_NOT_EQUAL},
      {name: 'Contém', value: EnumQueryOperators.OP_CONTAINS},
      {name: 'Não Contém', value: EnumQueryOperators.OP_NOT_CONTAINS},
      // {name: 'Está Entre', value: EnumQueryOperators.OP_BETWEEN},
      // {name: 'Não Está Entre', value: EnumQueryOperators.OP_NOT_BETWEEN},
      {name: 'Maior que', value: EnumQueryOperators.OP_GREATER},
      {name: 'Menor que', value: EnumQueryOperators.OP_LESSER},
      {name: 'Maior ou igual que', value: EnumQueryOperators.OP_GREATER_EQUAL},
      {name: 'Menor ou igual que', value: EnumQueryOperators.OP_LESSER_EQUAL},
    ];
  }

  private get conditionals() {
    return [
      {name: 'E', value: EnumLogicalOperator.OP_AND},
      {name: 'OU', value: EnumLogicalOperator.OP_OR},
    ];
  }

  /* tslint:enable */

  private get formData() {
    const data = readForm(this.$store)(+this.formId)?.form_setting?.form_data?.controls;
    if (data) {
      return Object.values(data).map((e: any) => {
        const name = e?.name ? e?.name : e?.uniqueId;
        return {uniqueId: e?.uniqueId, name: name, label: e?.label, type: e?.type};
      });
    }
    return null;
  }


  private addQueryItem() {
    this.queryBuilder.children.push({
      logical_operator: EnumLogicalOperator.OP_AND,
      query: {
        operator: EnumQueryOperators.OP_EQUAL,
        operand: null,
        query_value: null,
      },
    } as unknown as IQueryBuilder);
  }

  private removeQueryItem(index) {
    this.queryBuilder.children.splice(index, 1);
  }

  private getFieldType(item) {
    return item?.type;
  }

}
